export enum TaskDetailStatus {
    NoStatus = 0,
    Completed = 1, 
    NoShow = 2, 
    Refused = 3, 
    Rescheduled = 4,
    Canceled = 5
}